import { createRequest } from "helpers/tools";

export const postConnection = async (data) => {
    return await createRequest({
        suffix: `lead/save-connection`,
        method: "post",
        payload: data,
        handleError: false,
    });
};
